/**
 * Helper functions bridging game state and RapierWorld.
 * These are used by both server (GameLoop) and client (ClientPrediction).
 */
/**
 * Apply resolved input forces/rotation to a Rapier ship body.
 * Called per-ship before world.step().
 */
export function applyShipInput(world, entityId, thrustForce, rotationDelta, currentRotation) {
    world.applyShipForce(entityId, thrustForce);
    world.setShipRotation(entityId, currentRotation + rotationDelta);
}
/**
 * Extract physics state from Rapier after step, merge with game fields.
 * Returns a new MutableShipState (immutable pattern).
 */
export function extractShipAfterStep(world, ship, newBattery, isAfterburning, isThrusting, isBraking = false, isStrafingLeft = false, isStrafingRight = false, isFiring = false) {
    if (!ship.alive) {
        return {
            entityId: ship.entityId,
            x: ship.x,
            y: ship.y,
            vx: ship.vx,
            vy: ship.vy,
            rotation: ship.rotation,
            health: ship.health,
            battery: ship.battery,
            alive: ship.alive,
            afterburner: ship.afterburner,
            thrusting: ship.thrusting,
            braking: ship.braking,
            strafingLeft: ship.strafingLeft,
            strafingRight: ship.strafingRight,
            firing: ship.firing,
        };
    }
    const physics = world.extractShipState(ship.entityId);
    if (!physics) {
        return {
            entityId: ship.entityId,
            x: ship.x,
            y: ship.y,
            vx: ship.vx,
            vy: ship.vy,
            rotation: ship.rotation,
            health: ship.health,
            battery: ship.battery,
            alive: ship.alive,
            afterburner: ship.afterburner,
            thrusting: ship.thrusting,
            braking: ship.braking,
            strafingLeft: ship.strafingLeft,
            strafingRight: ship.strafingRight,
            firing: ship.firing,
        };
    }
    return {
        entityId: ship.entityId,
        x: physics.x,
        y: physics.y,
        vx: physics.vx,
        vy: physics.vy,
        rotation: physics.rotation,
        health: ship.health,
        battery: newBattery,
        alive: ship.alive,
        afterburner: isAfterburning,
        thrusting: isThrusting,
        braking: isBraking,
        strafingLeft: isStrafingLeft,
        strafingRight: isStrafingRight,
        firing: isFiring,
    };
}
//# sourceMappingURL=rapierPhysics.js.map